import { ApplicationConfig, importProvidersFrom, ImportProvidersSource, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { appProviders } from './app.providers';
import { CalAngularModule } from '@cvx/cal-angular';
import { environment } from '@environment/environment';
import { providePrimeNG } from 'primeng/config';
import { CVXPreset } from './shared/styles/cvx-preset';
import { TokenInterceptor } from './interceptors/token-interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([TokenInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: CVXPreset,
        options: {
          prefix: 'p',
          darkModeSelector: false,
          cssLayer: false,          
          inputStyle: 'filled',
        }
      },
      ripple: true
    }),
    importProvidersFrom(
      ...appProviders as ImportProvidersSource[],
      CalAngularModule.forRoot({
        "autoSignIn": environment.autoSignIn,
        "popupForLogin": environment.popupForLogin,
        "cacheLocation": environment.cacheLocation,
        "instance": environment.instance,
        "tenantId": environment.tenantId,
        "clientId": environment.clientId,
        "redirectUri": environment.redirectUri,
        "oidcScopes": environment.oidcScopes,
        "graphScopes": environment.graphScopes
      }))
  ]
};
